export default function isPrimaryPointer({
  evt
}, button = 0) {
  return evt.isPrimary && (evt.button === button || evt.pointerType !== 'mouse');
}